<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.keyword"
        placeholder="关键字搜索(名称)"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-select
        v-model="listQuery.type"
        placeholder="模板类型"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in FREIGHT_TYPE"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>

      <el-select
        v-model="listQuery.Integer"
        placeholder="寄件方式"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in FREIGHT_PRICING_METHOD"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>

      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        >搜索</el-button
      >
      <el-button
        class="filter-item"
        type="primary"
        @click="checkDialogFormVisible(true, {}, 'CREATE')"
        >新增</el-button
      >
    </div>

    <div style="margin-bottom: 5px">运费模版数量:{{ total }}</div>

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
    >
      <el-table-column
        align="center"
        prop="id"
        label="ID"
        width="95"
      ></el-table-column>
      <el-table-column
        label="商家编号"
        align="center"
        prop="mchId"
      ></el-table-column>
      <el-table-column
        label="模版名称"
        align="center"
        prop="name"
      ></el-table-column>
      <el-table-column
        label="运费"
        align="center"
        prop="postage"
      ></el-table-column>
      <el-table-column label="所选地区" align="type">
        <template slot-scope="scope">
          <span v-for="(item,index) in scope.row.areaList" key="index">{{item}}|</span>
        </template>
      </el-table-column>
      <el-table-column label="类型" align="type">
        <template slot-scope="scope">
          {{ getValue(FREIGHT_TYPE, scope.row.type) }}
        </template>
      </el-table-column>
      <el-table-column label="计价方式" align="charging">
        <template slot-scope="scope">
          {{ getValue(FREIGHT_PRICING_METHOD, scope.row.charging) }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="ctdate"
        label="创建时间"
        width="200px"
      >
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.ctdate) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="mddate"
        label="修改时间"
        width="200px"
      >
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.mddate) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="230"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            type="warning"
            size="mini"
            @click="checkDialogFormVisible(true, scope.row, 'UPDATE')"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!--    编辑和新增-->
    <el-dialog
      :title="DIALOG_TITLE_TYPE[dialogType]"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      destroy-on-close
      width="40%"
    >
      <el-form
        ref="form"
        :rules="rules"
        :model="form"
        label-position="left"
        label-width="150px"
        style="width: 80%; margin-left:50px;"
      >
        <el-form-item label="模版名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="模板类型" prop="type">
          <el-radio-group v-model="form.type">
            <el-radio
              v-for="item in FREIGHT_TYPE"
              :key="item.key"
              :label="item.key"
              >{{ item.value }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item label="计价方式" prop="charging">
          <el-radio-group v-model="form.charging">
            <el-radio
                v-for="item in FREIGHT_PRICING_METHOD"
                :key="item.key"
                :label="item.key"
            >{{ item.value }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item label="选择地区" prop="area">
          <el-select v-model="form.area" multiple placeholder="请选择"  style="width:100%">
            <el-option
              v-for="item in areaList"
              :key="item.name"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="运费" prop="postage">
              <el-input v-model="form.postage" placeholder="请输入标题" @input="onInput"
              />
        </el-form-item>
        <el-form-item label="运送方式信息" prop="transWay">
          <el-input
            type="textarea"
            v-model="form.transWay"
            placeholder="请输入"
          />
        </el-form-item>
        <el-form-item label="条件包邮信息" prop="condiExempt">
          <el-input
            type="textarea"
            v-model="form.condiExempt"
            placeholder="请输入"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="checkDialogFormVisible(false, {}, '')"
          >取消</el-button
        >
        <el-button
          type="primary"
          @click="saveAddOrEditData"
          :loading="btnLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getPostagesList, editPostages,getCascadeRegion } from "@/api/store";
import { formatApiDate } from "@/utils/utils";
import {
  DIALOG_TITLE_TYPE,
  getValue,
  FREIGHT_TYPE,
  FREIGHT_PRICING_METHOD
} from "@/utils/enumUtile";

export default {
  computed: {
    formatApiDate() {
      return formatApiDate;
    },
    DIALOG_TITLE_TYPE() {
      return DIALOG_TITLE_TYPE;
    },
    FREIGHT_TYPE() {
      return FREIGHT_TYPE;
    },
    FREIGHT_PRICING_METHOD() {
      return FREIGHT_PRICING_METHOD;
    }
  },
  components: {},
  filters: {},
  data() {
    return {
      list: null,
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        pageSize: 20,
        keyword: null,
        type: null,
        Integer: null
      },
      dialogFormVisible: false,
      dialogType: "",
      rules: {
        type: [
          { required: true, message: "模板类型不能为空", trigger: "change" }
        ],
        charging: [
          { required: true, message: "计价方式不能为空", trigger: "change" }
        ],
        name: [
          { required: true, message: "品牌名称不能为空", trigger: "change" }
        ],
        area: [
          { required: true, message: "地区不能为空", trigger: "change" }
        ],
        postage: [
          { required: true, message: "运费不能为空", trigger: "change" }
        ]
      },
      form: {
        id: 0,
        type: '', //省份ID
        charging: '', // 城市ID
        name: '',
        transWay: [], // 运送方式信息
        condiExempt: [], // 条件包邮信息
        area:[],
        postage:'',

      },
      btnLoading: false,
      areaList:[]
    };
  },
  created() {
    this.cascadeRegion();
  },
  watch: {},
  methods: {
    getValue,
    cascadeRegion(){
      let params = {
        parentId:47021
      }
      getCascadeRegion(params).then((res)=>{
        if(res.bizcode == 100){
          this.areaList = res.data;
            this.getList();
        }
      })
    },
    checkInputPrice1(value,max = null) {
      if(max === 0){
        return '';
      }
      // value = value.replace(/^0*/g, ''); // 第一个数不能为0 ，若为0替换为空
      value = value.replace(/[^\d.]/g, ""); // 是否是数字 和小数点，若是除数字 和小数点之外的则替换为空
          value = value.replace(/^\./g, ""); // 确证第一个为数字而不是“.”
          value = value.replace(/\.{2,}/g, "."); // 只能输入一个“.”
          value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", "."); // 保证”.“只出现一次，而不能出现两次以上
          value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); // 只能输入两个小数
      if(max && value >= max){
        value = max;
      }
      return value;
    },
    onInput(e){
      this.$nextTick(()=>{
        this.form.postage = this.checkInputPrice1(e);
      })
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },

    /**
     * 查询列表
     */
    getList() {
      this.listLoading = true;
      const form = this.listQuery;
      const params = {
        ...form
      };
      getPostagesList(params)
        .then(response => {
          this.list = response.data.entitys;
          this.total = response.data.totalCount;
          this.list.forEach(item=>{
            if(item.area){
              
              item.areaList = item.area.split(',');
              
            }
          })
          console.log('item',this.list)
        })
        .finally(() => {
          this.listLoading = false;
        });
    },

    /**
     * 切换状态
     * @param status
     * @param editObj
     * @param type
     */
    checkDialogFormVisible(status, editObj = {}, type) {
 console.log('this.form',type)
      if (status && type === "UPDATE") {
        this.form.id = editObj.id;
        this.form.type = editObj.type;
        this.form.name = editObj.name;
        this.form.charging = editObj.charging;
        this.form.transWay = editObj.transWay;
        this.form.condiExempt = editObj.condiExempt;
        this.form.area = editObj.area.split(',');
       
       
        this.form.postage = editObj.postage;
      }else{
        

        if(this.$refs && this.$refs.form){

          this.$refs.form.resetFields();

        }
        this.form.id = 0;
        this.form.type = '';
        this.form.charging = '';
        this.form.name = '';
        this.form.transWay = [];
        this.form.condiExempt = [];
        this.form.area = [];
        this.form.postage = '';
      }
          console.log('type2222',this.form)
      this.dialogType = type;
      this.dialogFormVisible = status;

    },
    /**
     * 确认添加还是编辑
     */
    saveAddOrEditData() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const form = this.form;
          console.log('form',JSON.parse(JSON.stringify(this.form)))
          const params = {
            type: form.type,
            name: form.name,
            charging: form.charging,
            area:form.area.join(','),
            postage:Number(form.postage),
            transWay: form.transWay,
            condiExempt: form.condiExempt
          };
          if (form.id && form.id !== 0) {
            params.id = form.id;
          }
          this.btnLoading = true;
          editPostages(params)
            .then(() => {
              this.getList();
              this.checkDialogFormVisible(false);
              this.$notify({
                title: "成功",
                message: "保存成功",
                type: "success",
                duration: 2000
              });
            })
            .finally(() => {
              this.btnLoading = false;
            });
        }
      });
    }
  }
};
</script>
<style scoped lang="scss"></style>
